import { render, staticRenderFns } from "./ReviewsSettingsCreateOrEditBusinessTab.vue?vue&type=template&id=978a4322&"
import script from "./ReviewsSettingsCreateOrEditBusinessTab.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettingsCreateOrEditBusinessTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports